export enum GOAL_TYPE {
  MARKETPLACE = 1,
  PRODUCT
}
